import { BaseUpdateComponent, BaseDataService, InputComponent, QueryParameter, NumberInputComponentV3, UserService, ModalService, NotificationService, ErrorHandlerService, ConfirmationDialogButtons } from 'yt-ng-framework';
import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';
import { Observable, of, Subject, Subscription } from 'rxjs';
import * as var_config from '../../var_config';
import { List } from 'immutable';
import { RobaView } from 'src/app/lookups/roba/roba-view';
import { HttpErrorResponse } from '@angular/common/http';
import { AkciznaRobaTipPakovanjaView } from 'src/app/lookups/akcizna-roba-tip-pakovanja/akcizna-roba-tip-pakovanja-view';
import { AkciznaRobaTipPakovanja } from 'src/app/lookups/akcizna-roba-tip-pakovanja/akcizna-roba-tip-pakovanja';
import { EPrijemnicaStavka } from './eprijemnica-stavka';
import { EPrijemnicaService } from './eprijemnica-service';

@Component({
  selector: 'yt-eprijemnica-stavka-update',
  templateUrl: './eprijemnica-stavka-update.component.html',
  styleUrls: ['./eprijemnica-stavka-update.component.scss']
})
export class EPrijemnicaStavkaUpdateComponent
 extends BaseUpdateComponent<EPrijemnicaStavka>
 implements OnInit, OnDestroy {
  izlazna: boolean = false;
  varConfig=var_config;
  razvoj: boolean = true;
  showDodatniAtributi: boolean = false;
  brojDodatnihAtributa: number = 0;

    @ViewChild('nestedInline') nestedInline;
    @ViewChild(BaseUpdateComponent, { static: false })
    public base: BaseUpdateComponent<EPrijemnicaStavka>;

    constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected prjemnicaService: EPrijemnicaService,
    protected decimalPipe: DecimalPipe,
    protected userService: UserService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected modalService: ModalService,
    protected errorService: ErrorHandlerService
      ) {
        super(activatedRoute, baseDataService, toastrService, translateService, modalService);
    
      }

    ngOnInit() {
      super.ngOnInit();
      // this.izlazna=this.modelData.MainTitle==='Izlazna prijemnica';
      // if (this.Parameters && this.Parameters.get(1))
      //       this.izlazna = Boolean(this.Parameters.get(1).get(0).Value);

      // // this.baseFormGroup.get("RedniBroj").disable();
      // this.baseFormGroup.get('RedniBroj').updateValueAndValidity();
      // this.baseFormGroup.get("Kolicina").disable();
      // this.baseFormGroup.get('Kolicina').updateValueAndValidity();
      // this.baseFormGroup.get("VracenaKolicina").disable();
      // this.baseFormGroup.get('VracenaKolicina').updateValueAndValidity();
      // this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);

      this.IDProcessed
            .subscribe((value) => {
                if(value){                 
                  this.showDodatniAtributi = false;
                  if (this.Parameters && this.Parameters.get(1))
                    this.izlazna = Boolean(this.Parameters.get(1).get(0).Value);

                  if (this.izlazna){
                    this.baseFormGroup.get("RedniBroj").disable();
                    this.baseFormGroup.get('RedniBroj').updateValueAndValidity();
                    this.baseFormGroup.get("Sifra").disable();
                    this.baseFormGroup.get('Sifra').updateValueAndValidity();
                    this.baseFormGroup.get("Naziv").disable();
                    this.baseFormGroup.get('Naziv').updateValueAndValidity();
                    this.baseFormGroup.get("JedinicaMere").disable();
                    this.baseFormGroup.get('JedinicaMere').updateValueAndValidity();
                    
                    this.baseFormGroup.get("Kolicina").disable();
                    this.baseFormGroup.get('Kolicina').updateValueAndValidity();
                    this.baseFormGroup.get("VracenaKolicina").disable();
                    this.baseFormGroup.get('VracenaKolicina').updateValueAndValidity();
                    this.baseFormGroup.get("AkciznaRoba").disable();
                    this.baseFormGroup.get('AkciznaRoba').updateValueAndValidity();
                    this.baseFormGroup.get("AkciznaRobaTipPakovanja").disable();
                    this.baseFormGroup.get('AkciznaRobaTipPakovanja').updateValueAndValidity();
                    this.baseFormGroup.get("AkciznaRobaTipPakovanjaVrednost").disable();
                    this.baseFormGroup.get('AkciznaRobaTipPakovanjaVrednost').updateValueAndValidity();
                    this.baseFormGroup.get("AkciznaRobaSifraRobneMarke").disable();
                    this.baseFormGroup.get('AkciznaRobaSifraRobneMarke').updateValueAndValidity();
                       
                    this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
                  }
                  else{
                     this.baseFormGroup.disable();
                     this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
                  }
                  
                 
                }
                
            })       

    } 

    ngOnDestroy(){ }

    Save() {
      this.baseFormGroup.updateValueAndValidity({ emitEvent: false });
      super.SaveItem();
    }

    onToggleDodatniAtributi() {
      if (this.showDodatniAtributi && this.nestedInline) {
        this.nestedInline.SetDetailModelData(
          this.modelData.MainList.DetailList[3]
        );
      }
    }

    onPristiglaKolicinaChange(value){
      let _value: number = Number(value);
      let _primljenaKolicina: number = this.baseFormGroup.get("PrimljenaKolicina").value;
      let _razlika: number = _value - _primljenaKolicina;
      this.baseFormGroup.patchValue({VracenaKolicina: _razlika});
      this.baseFormGroup.get('VracenaKolicina').updateValueAndValidity();
    }

    onPrimljenaKolicinaChange(value){
      let _value: number = Number(value);
      let _pristiglaKolicina: number = this.baseFormGroup.get("PristiglaKolicina").value;
      let _razlika: number = _pristiglaKolicina -_value;
      this.baseFormGroup.patchValue({VracenaKolicina: _razlika});
      this.baseFormGroup.get('VracenaKolicina').updateValueAndValidity();
    }




        
}